// redux/actions/estados/types.js
export const FETCH_ESTADOS_SUCCESS = "FETCH_ESTADOS_SUCCESS";
export const FETCH_ESTADOS_FAILURE = "FETCH_ESTADOS_FAILURE";
